import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { GroupsService } from "../../../../services/groups.service";
import { StudentGroupsTableRefreshService } from "../../shared/student-groups-table-refresh.service";
import { GroupActionFineInsertRequest } from "./GroupActionFineInsertRequest";
import * as moment from "moment";

@Component({
	selector: "app-sgadd-fine",
	templateUrl: "./sgadd-fine.component.html",
	styleUrls: ["./sgadd-fine.component.css"],
})
export class SGAddFineComponent implements OnInit {
	constructor(
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private groupService: GroupsService,
		private confirmationService: ConfirmationService,
		private refreshService: StudentGroupsTableRefreshService
	) {}

	ngOnInit(): void {
		//Load data from parent
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedGroup = this.dialogConfig.data.SelectedGroup;

		this.SelectedGroupName = this.SelectedGroup.GroupName;
		this.SelectedGroupID = this.SelectedGroup.GroupID;

		//Get data from DB
		this.loadFineTypeList();
		this.loadAdminPersonList();
	}

	///////////////////////////
	// Data
	///////////////////////////

	user: any;
	SchoolID: any;
	SelectedGroup: any;

	SelectedGroupID: any = "";
	SelectedGroupName: any = "";

	//Form Data
	ActionDate: any = new Date();
	SelectedFineType: any;
	AdminPersonID: any = 0;
	SelectedFineAmount: String = "0.00";
	Comments: any = "";

	//Lists
	lstFineType: any = [];
	lstAdminUsers: any = [];

	//General
	errorMessage: any = "";
	///////////////////////////

	///////////////////////////
	// Load Data
	///////////////////////////

	loadFineTypeList() {
		var result = this.groupService.FineTypeGetList("", 1, 1, this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstFineType = response;
				this.SelectedFineType = this.lstFineType[0];

				if (this.SelectedFineType != undefined) {
					this.SelectedFineAmount = this.SelectedFineType.AccountDebitDefaultAmount;
				}
			},
			(error) => {}
		);
	}

	loadAdminPersonList() {
		var result = this.groupService.AdminGetList("", this.SchoolID, 1);
		result.subscribe(
			(response) => {
				this.lstAdminUsers = response;
				// this.lstAdminUsers.unshift({
				//   Administrator: "NONE",
				//   AdministratorID: -1
				// });
				this.AdminPersonID = this.lstAdminUsers[0].AdministratorID;
			},
			(error) => {}
		);
	}

	///////////////////////////

	///////////////////////////
	// Buttons
	///////////////////////////
	onAddFine() {
		this.errorMessage = "";

		//Error handling
		var int = Number(this.SelectedFineAmount);

		if (isNaN(int)) {
			this.errorMessage = "Enter a valid number for the fine amount";
			return;
		}

		if (Number(this.SelectedFineAmount) >= 99.99) {
			this.errorMessage = "Fine amount must be less than $99.99";
			return;
		}

		var adminID = 0;

		// adminID = this.AdminPersonID;

		adminID = this.user.personID;

		let parms: GroupActionFineInsertRequest = {
			ApplicationItemID: "",
			GroupID: this.SelectedGroupID,
			AccountID: 1,
			FineDT: moment(this.ActionDate).format("YYYY-MM-DD HH:mm"),
			AccountDebitTypeID: this.SelectedFineType.AccountDebitTypeID,
			AccountCreditTypeID: -1,
			Amount: this.SelectedFineAmount.toString(),
			SchoolID: this.SchoolID,
			Comments: this.Comments,
			AdminPersonID: adminID,
		};

		var result = this.groupService.GroupActionFineInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "fine",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Group Fine was added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.refreshService.GroupActionRefreshChanged(moment(new Date()).format("MM/DD/YYYY HH:mm:ss"));
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "fine",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Fine to the Group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}
	onClose() {
		this.ref.close(0);
	}
	///////////////////////////

	///////////////////////////
	// Events
	///////////////////////////
	onFineTypeChange(val) {
		this.SelectedFineType = val;

		this.SelectedFineAmount = this.SelectedFineType.AccountDebitDefaultAmount;
	}
	///////////////////////////
}
